import { useLayer } from '@eventbrite/statsig';
import {
    ExpressPaymentMethods,
    GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    InitialExperimentPostPaymentQuestionsVariant,
    INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS,
    SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
} from '../../constants/statsig';

export const useIsUrgencySignalsExperimentEnabled = (): boolean => {
    const { value } = useLayer(
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const useIsScrollableCtaExperimentEnabled = (): boolean => {
    const { value } = useLayer(
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const useIsGooglePayOnTicketSelectionExperimentEnabled =
    (): ExpressPaymentMethods => {
        const { value } = useLayer<
            ExpressPaymentMethods,
            ExpressPaymentMethods
        >(
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
        );

        return value;
    };

export const useGetInitialExperimentpostPaymentQuestionsValue =
    (): InitialExperimentPostPaymentQuestionsVariant => {
        const { value } = useLayer<
            InitialExperimentPostPaymentQuestionsVariant,
            InitialExperimentPostPaymentQuestionsVariant
        >(
            INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS.layer,
            INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS.param,
            INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS.defaultValue,
        );

        return value;
    };
